import { graphql } from '@api/highnote'

export const CREATE_DOCUMENT_UPLOAD_SECURE_LINK = graphql(`
  mutation CreateDocumentUploadSecureLink($input: CreateDocumentUploadLinkInput!) {
    createDocumentUploadLink(input: $input) {
      __typename
      ... on DocumentUploadLink {
        uploadUrl
      }
      ... on UserError {
        errors {
          path
          code
          description
          errorPath
        }
      }
    }
  }
`)

export const END_DOCUMENT_UPLOAD_SESSION = graphql(`
  mutation EndDocumentUploadSession($input: EndDocumentUploadSessionInput!) {
    endDocumentUploadSession(input: $input) {
      __typename
      ... on USAccountHolderApplicationDocumentUploadSession {
        id
        status
        primaryDocumentTypes
        uploadRequirements {
          constraints {
            ... on DocumentUploadRequirementConstraint {
              documentType
              numberOfDocuments
            }
          }
        }
      }
      ... on UserError {
        errors {
          path
          code
          description
        }
      }
      ... on AccessDeniedError {
        message
      }
    }
  }
`)
